import { buildApiUrl } from '../../../../shared_app/utils/buildApiUrl';
var WEEKLY_REPORT_API = {
    reportData: buildApiUrl('/api/teachers/groups/:groupId/weekly_report'),
};
export { WEEKLY_REPORT_API };
